import { Pipe, PipeTransform } from '@angular/core'
import { TextBlockStyle } from '@lg/shared'

@Pipe({
	name: 'replaceNewlines',
	standalone: false,
})
export class ReplaceNewlinesPipe implements PipeTransform {
	transform(
		value: string | { changingThisBreaksApplicationSecurity: string },
		tagName: TextBlockStyle,
	) {
		if (!value) return value

		const isSafeHtml =
			typeof value == 'object' && !!value.changingThisBreaksApplicationSecurity
		let html = isSafeHtml
			? value.changingThisBreaksApplicationSecurity
			: (value as string)

		if (tagName == 'p') {
			html = `<p>${html.replace(/\n[ \t]*\n/g, '</p><p>')}</p>`
		}
		html = html.replace(/\n/g, '<br>')

		if (isSafeHtml) {
			value.changingThisBreaksApplicationSecurity = html
			return value
		}
		return html
	}
}
